import { useBusinessEntity } from '@zenbusiness/application-commons-business-entity';
import { useButtonPressedCallback } from '@zenbusiness/application-commons-clickstream';
import Text from '@zenbusiness/common-components/Text';
import Title from '@zenbusiness/common-components/Title';
import { useParams, Link as RouterLink } from 'react-router-dom';

import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

const StyledGrid = styled(Grid)(({ theme }) => ({
  flexDirection: 'column',
  justifyContent: 'flex-start',
  textAlign: 'center',
  paddingLeft: theme.spacing(2),
  paddingRight: theme.spacing(2),
  position: 'absolute',
  left: 0,
  width: '100vw',
  '& h1': {
    paddingBottom: theme.spacing(1.5)
  },

  [theme.breakpoints.up('sm')]: {
    position: 'relative',
    width: '100%'
  }
}));

const StyledTopContainer = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(2.5),
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),

  [theme.breakpoints.up('sm')]: {
    maxWidth: '540px',
    marginLeft: 'auto',
    marginRight: 'auto'
  }
}));

const StyledButtonGroup = styled('div')(({ theme }) => ({
  marginTop: theme.spacing(5),
  paddingLeft: theme.spacing(1.5),
  paddingRight: theme.spacing(1.5),

  [theme.breakpoints.down('sm')]: {
    position: 'fixed',
    bottom: 0,
    width: '100vw',
    left: 0,
    margin: 0,
    paddingLeft: 0,
    paddingRight: 0,
    justifyContent: 'space-between',
    '& a,button': {
      borderRadius: 0,
      width: '100vw',
      height: '64px',
      opacity: 1
    },
    '& a:disabled': {
      backgroundColor: 'rgba(220, 218, 216, 1)'
    }
  }
}));

const StyledButton = styled(Button)(({ theme }) => ({
  [theme.breakpoints.up('sm')]: {
    width: '360px',
    textAlign: 'center'
  }
}));

const ExternalDomainVerify = () => {
  const { businessEntityUuid } = useBusinessEntity();
  const { domainUuid } = useParams();

  const handleFinishClick = useButtonPressedCallback({
    elementName: 'finish_verify',
    elementText: 'FINISH',
    pageCategory: 'dashboard',
    pageSection: 'growth',
    screenName: 'external_verify'
  });

  return (
    <StyledGrid container direction="column" justifyContent="flex-start">
      <StyledTopContainer>
        <Title
          variant="hg"
          level={2}
          gutterBottom
        >
          Next Steps
        </Title>
        <Text size="md">
          Verifying the connection between your domain registered elsewhere, and
          ZenBusiness website can take between 24-48 hours.
          <br />
          <br />
          Our system will continue testing for a successful connection,
          and once a successful connection has been made,
          you will be able to visit your domain and see your website.
        </Text>
      </StyledTopContainer>
      <StyledButtonGroup>
        <StyledButton
          size="large"
          variant="contained"
          color="primary"
          onClick={handleFinishClick}
          component={RouterLink}
          to={`/d/company/${businessEntityUuid}/marketing-tools/domains/${domainUuid}`}
        >
          FINISH
        </StyledButton>
      </StyledButtonGroup>
    </StyledGrid>
  );
};

export default ExternalDomainVerify;
